import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { connectRoutes } from 'redux-first-router';
import { CookiesProvider } from 'react-cookie';
import thunk from 'redux-thunk';
import queryString from 'query-string';
import 'draft-js/dist/Draft.css';
import './index.css';
import App from './components/pages/MainPage';
import { startAuthListener } from './actions/auth';
import { initProfile } from './actions/profile';
import { registListener, unregistListener, initRecipes } from './actions/recipe';
import { createQuizReducer, authReducer, playQuizReducer, recipeDetailReducer, searchRecipesReducer, pageReducer, profileReducer, userReducer, recipeReducer } from './reducers/';
import routesMap from './routesMap';
import dotenv from 'dotenv';
import registerServiceWorker from './registerServiceWorker';

dotenv.load();

const { reducer, middleware, enhancer } = connectRoutes(routesMap, {
	querySerializer: queryString
});
const middlewares = applyMiddleware(middleware, thunk);
const store = createStore(
	combineReducers({
		location: reducer,
		createQuiz: createQuizReducer,
		playQuiz: playQuizReducer,
		auth: authReducer,
		searchRecipesReducer,
		page: pageReducer,
		recipeDetailReducer,
		profileReducer,
		userReducer,
		recipeReducer
	}), compose(enhancer, middlewares)
);

const render = () => {
	ReactDOM.render(
		<CookiesProvider>
			<Provider store={store}>
				<App />
			</Provider>
		</CookiesProvider>
		,
		document.getElementById('root')
	);
};
render();
store.subscribe(render);
startAuthListener(store, function () {
	store.dispatch(registListener);
}, function(){
	store.dispatch(unregistListener);
	store.dispatch(initProfile);
	store.dispatch(initRecipes);
});
registerServiceWorker();
